/** Route metadata shared by the browser and Vite build.
 * Related: app-router.js, vite.config.js, games.js.
 */
import { games } from '../data/games.js';
import { siteConfig } from '../data/site-config.js';
export const publicPaths = ['/', ...games.map((game) => `/games/${game.id}`), '/ant-clash/privacy', '/beatglide/privacy', '/beatglide/terms'];
export const getMetadata = (path) => {
  const normalized = path.replace(/\/$/, '') || '/';
  const game = games.find((item) => normalized === `/games/${item.id}` || (item.id === 'ant-clash' && normalized === '/ant-clash'));
  const privacyGame = games.find((item) => [`/${item.id}/privacy`, `/games/${item.id}/privacy`, `/privacy/${item.id}`].includes(normalized) && ['ant-clash', 'beatglide'].includes(item.id));
  const privacy = Boolean(privacyGame);
  const terms = normalized === '/beatglide/terms';
  const unknown = !game && !privacy && !terms && normalized !== '/';
  return {
    title: terms ? 'BeatGlide Terms of Use | SNT Games' : normalized === '/admin' ? 'Admin | SNT Games' : game ? `${game.title} | SNT Games` : privacy ? `${privacyGame.title} Privacy Policy | SNT Games` : unknown ? '404 | SNT Games' : 'SNT Games — Independent Game Studio',
    description: terms ? 'Terms of use for BeatGlide, for players aged 13 and older.' : game ? game.shortDescriptionEn || 'Command your ant army, capture nests and upgrade your colony in Ant Clash, a mobile real-time strategy game.' : privacy ? `Read the privacy policy and support contact for ${privacyGame.title}.` : siteConfig.description,
    url: `${siteConfig.domain}${privacy ? `/${privacyGame.id}/privacy` : game ? `/games/${game.id}` : normalized}`,
    image: `${siteConfig.domain}${game?.coverImage || '/assets/images/brand/logo.webp'}`,
    noindex: unknown,
  };
};
export const updateMetadata = (path) => {
  const meta = getMetadata(path);
  document.title = meta.title;
  document.querySelector('link[rel="canonical"]').href = meta.url;
  const values = { description: meta.description, 'og:title': meta.title, 'og:description': meta.description, 'og:url': meta.url, 'og:image': meta.image, 'twitter:title': meta.title, 'twitter:description': meta.description, 'twitter:url': meta.url, 'twitter:image': meta.image };
  Object.entries(values).forEach(([key, value]) => {
    document.querySelector(`meta[name="${key}"], meta[property="${key}"]`).content = value;
  });
  let robots = document.querySelector('meta[name="robots"]');
  if (!robots) { robots = document.createElement('meta'); robots.name = 'robots'; document.head.appendChild(robots); }
  robots.content = meta.noindex ? 'noindex, follow' : 'index, follow';
};
